// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__ajkB3","option":"Toggle_option__YFFZA","radioInput":"Toggle_radioInput__AFU4W","button":"Toggle_button__T56Bv"};